// extracted by mini-css-extract-plugin
export default {"AddNewGoalPop":"addForm_AddNewGoalPop__mUgQK","modalBody":"addForm_modalBody__puxLp","formControl":"addForm_formControl__NFgEO","add":"addForm_add__RwVsi"};